import { getFeatureFlag } from '@/lib/featureFlags';

// THE feature-flag mechanism for TK. CLAUDE.md prescribes flag-gating whenever
// a frontend PR lands ahead of its backend ("ship behind a feature flag, flip
// it once the backend is live") — this hook is what that instruction points at.
//
// Flags now resolve from a committed constants file (`lib/featureFlags.ts`),
// not PostHog (removed 2026-07-06 — orphaned third-party account, client flags
// were 401-dead in prod anyway). Flipping a flag is a one-line edit + merge
// (Vercel auto-deploys); the kill-switch is flip-back + revert-deploy (~2 min).
//
// Contract (unchanged): `fallback` is used whenever `key` isn't declared in the
// constants file, so callers keep their safe backend-less default. Not for
// dev-only graphics A/B toggles — that's `lib/features.ts` (URL-param, DEV).
export function useFeatureFlag(key: string, fallback: boolean): boolean {
  const declared = getFeatureFlag(key);
  return typeof declared === 'boolean' ? declared : fallback;
}
